import request from './index'

export const messageList = listQuery => {
    return request({
      url: '/user/message/list',
      method: 'post',
      data: {
        command_id: 0,
        pageIndex: listQuery.pageIndex,
        pageSize: listQuery.pageSize,
      }
    })
  }